import qs from "qs";
import {
  UTM_TAGS,
  GCLID_COOKIE,
  GOOGLE_ANALYTICS_COOKIE
} from "global/constants";
import Cookies from "cookies-js";
import storage from "local-storage-fallback";

class LocalOperations {
  static parseUrlParams() {
    const queryString = LocalOperations.decodeDoubleUnderscores(
      window.location.search
    );
    return qs.parse(queryString, {
      ignoreQueryPrefix: true,
      allowDots: true
    });
  }

  static decodeDoubleUnderscores(string) {
    // double underscores will be interpreted as percent symbols for platforms to support
    // full unicode for platforms that only support basic ascii
    return string.replace(/__/g, "%");
  }

  static getUtmTags() {
    return UTM_TAGS.reduce((accumulator, tag) => {
      const value = Cookies.get(tag) || storage.getItem(tag);
      if (value) {
        accumulator[tag] = value; // eslint-disable-line no-param-reassign
      }
      return accumulator;
    }, {});
  }

  static getGoogleAnalyticsCookie() {
    return Cookies.get(GOOGLE_ANALYTICS_COOKIE) || null;
  }

  static getGclidCookie() {
    return Cookies.get(GCLID_COOKIE) || null;
  }

  static getGclidFromUrl() {
    // For unbounce pages utilising the embeddable handler the gclid will be passed
    // via a hidden Zoho field in the form of zc_gad
    const gclid = this.parseUrlParams().zc_gad;
    return gclid;
  }
}

export default LocalOperations;
